<template>
  <div>
    <b-container>
      <h1 class="text-left mt-2 mb-4">Híreink</h1>
      <div style="margin-left: -15px;margin-right: -15px;" v-if="showAnim">
        <div class="heading-news" v-if="visibleNews.length >= 3">
          <b-row>
            <b-col sm="12" md="12" lg="6" xl="6">
              <div class="big">
                <news-card :newsItem="visibleNews[0]" :showImg="true" />
              </div>
            </b-col>
            <b-col sm="12" md="12" lg="6" xl="6">
              <div class="small1">
                <news-card :newsItem="visibleNews[1]" :showImg="false" />
              </div>
              <div class="small2 mt-4">
                <news-card :newsItem="visibleNews[2]" :showImg="false" />
              </div>
            </b-col>
          </b-row>
        </div>

        <transition name="fade">
          <b-card-group v-if="showAnim">
            <b-col
              class="text-left same-height"
              sm="12"
              md="12"
              lg="6"
              xl="4"
              v-for="(news, index) in visibleNews"
              :key="index"
            >
              <news-card :newsItem="news" :showImg="true" v-if="index >= 3" />
            </b-col>
          </b-card-group>
        </transition>
      </div>
      <infinite-loading @infinite="infiniteHandler" v-if="showAnim">
        <div slot="no-more">Nincs több hír.</div>
        <div slot="no-results">Nem található.</div>
      </infinite-loading>
    </b-container>
  </div>
</template>

<script>
import NewsCard from './NewsCard'
import InfiniteLoading from 'vue-infinite-loading'
// https://github.com/PeachScript/vue-infinite-loading
import api from '../../api/api'
import { newsCmsBasePath } from '../../api/news'

export default {
  name: 'NewsPage',
  components: {
    NewsCard,
    InfiniteLoading
  },
  data() {
    return {
      visibleNews: [],
      showAnim: false,
      currentPage: 0,
      currentLimit: 3,
      bottom: false
    }
  },
  methods: {
    newsDate(date) {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString('hu-HU', options)
    },
    infiniteHandler($state) {
      api.get(`${newsCmsBasePath}/public/${this.currentPage}/${this.currentLimit}`, {}).then(({ data }) => {
        if (data.items.length) {
          this.currentPage += 1
          this.visibleNews.push(...data.items)
          $state.loaded()
        } else {
          $state.complete()
        }
      })
    }
  },
  async created() {
    this.$gtag.event('user_news', {
      event_category: 'user_interaction'
    })

    api.get(`${newsCmsBasePath}/public/${this.currentPage}/${this.currentLimit}`, {}).then(({ data }) => {
      if (data.items.length) {
        this.currentPage += 1
        this.visibleNews.push(...data.items)
        this.showAnim = true
      }
    })
  }
}
</script>

<style scoped>
.heading-news {
  margin-bottom: 2rem;
  text-align: left;
}

.heading-news .big {
  max-width: 560px;
  min-height: 740px;
  border: 1px solid #dfe6e9;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(45, 52, 54, 0.05);
  border-radius: 80px 80px 0px 80px;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 40px;
  margin-bottom: 2rem;
}

.heading-news .small1 {
  max-width: 558px;
  min-height: 358px;
  border: 1px solid #dfe6e9;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(45, 52, 54, 0.05);
  border-radius: 80px 80px 80px 0px;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 15px;
}

.heading-news .small2 {
  max-width: 558px;
  min-height: 358px;
  border: 1px solid #dfe6e9;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(45, 52, 54, 0.05);
  border-radius: 0px 80px 80px 80px;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 15px;
}

.same-height {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
</style>
